import { render, staticRenderFns } from "./Extensions2_1.vue?vue&type=template&id=37023d70&scoped=true"
import script from "./Extensions2_1.vue?vue&type=script&lang=js"
export * from "./Extensions2_1.vue?vue&type=script&lang=js"
import style0 from "./Extensions2_1.vue?vue&type=style&index=0&id=37023d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37023d70",
  null
  
)

export default component.exports